export default __webpack_public_path__ + "static/media/NewBook.4ef607f8.png";